module.exports = __webpack_public_path__ + "static/media/magazine-4.d1b6dc9f.jpg";